import { render } from "./requestForm.vue?vue&type=template&id=6ca9406d"
import script from "./requestForm.vue?vue&type=script&lang=js"
export * from "./requestForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__